import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import EntityHeader from "../../shared/Entity/EntityHeader";
import Commercial from "../../shared/Commercial";
import { visitUser } from "../../api/visit";
import { usePlayerProfileDetails, usePlayerProfileSkills } from "../../api/queries/profile/playerProfileQueries";

import EntityTabs from "./Components/EntityTabs";

const Player = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const { userId } = useParams();

  useEffect(() => {
    if (!userId) return;
    (async () => await visitUser(userId))();
  }, [userId]);

  const { playerInfo, isPlayerInfoLoading, isPlayerInfoHasError } = usePlayerProfileDetails(userId!);
  const { skillsList, isSkillsListLoading, isSkillsListHasError } = usePlayerProfileSkills(userId!);

  const handleChangeTabValue = (event: React.SyntheticEvent, newValue: number): void => {
    setTabValue(newValue);
  };

  if (isPlayerInfoHasError) {
    return <Box>No player found.</Box>;
  }

  const totalEndorsementCount = skillsList?.data.reduce((sum, item) => sum + Number(item.count), 0);

  return (
    <Box sx={{ display: "flex", columnGap: "8px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "644px",
        }}
      >
        <EntityHeader entityInfo={playerInfo} isLoading={isPlayerInfoLoading} />
        <EntityTabs
          tabValue={tabValue}
          entityInfo={playerInfo}
          handleChangeTabValue={handleChangeTabValue}
          skills={skillsList?.data}
          endorsementNumber={totalEndorsementCount}
          isLoading={isSkillsListLoading}
        />
      </Box>
      <Commercial />
    </Box>
  );
};

export default Player;
